import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef} from '@angular/core';
import { formatDate } from '@angular/common';
import { LocalStorage } from 'ngx-store';
import { DragulaService } from 'ng2-dragula';
import { NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, FormArray, FormControl} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { ServiceTypeAbbreviations } from '../service-type-abbreviations.enum';

// Models
import { Url, User } from '../../../model/users.model';
import { GeofenceRadius, Run, RunDriver, RunEquipment, RunPlanActivity} from 'src/app/model/dispatch.model';

// Services
import { DispatchService } from '../../../services/dispatch.service';
import { LocalDispatchService } from '../../../services/local-dispatch.service';
import { DriversService } from '../../../services/drivers.service';
import { FleetPairingService } from '../../../services/fleet-pairing.service';
import { DriverTruckPairingService } from '../../../services/driver-truck-pairing.service';
import { ComponentsSettingsService} from '../../../services/components_settings.service';

// for Dragula Multiple Selection 
import $ from 'jquery';
import { IMyDpOptions } from 'mydatepicker';

@Component({
  selector: 'app-local-dispatch',
  templateUrl: './local-dispatch.component.html',
  styleUrls: ['./local-dispatch.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [LocalDispatchService, DispatchService, DriversService, DragulaService]
})
export class LocalDispatchComponent implements OnInit {
  @LocalStorage() url!: Url;
  @LocalStorage() user!: User;
  
  loadConsignmentSpinner: boolean = true;
  loadDispatchingConsignment: boolean = false;
  loadCarrierSpinner: boolean = true;
  loadManifestSpinner: boolean = true;

  // Select All Consignment
  hasMultiple = false;
  selectedItems;
  mirrorContainer;
  movedItems = [];

  //forms
  filterForm  : FormGroup;

  subStatuses = [
    {id: 1 ,name: 'All'},
    {id: 2 ,name: 'Dispatched'},
    {id: 3 ,name: 'Accepted'},
    {id: 4 ,name: 'In Transit'},
    {id: 5 ,name: 'Picked Up'},
    {id: 6 ,name: 'Delivering'},
    {id: 7 ,name: 'Delivered'},
    // {id: 8 ,name: 'Cancelled'},
  ];

  ORDER_TYPES_LABEL = {
    ALL: 'All',
    PURCHASEORD: 'Purchase Order',
    SALESORD: 'Sales Order'
  }

  public job_Type = 1; //local
  public dispatchNotes       = "Please take breaks as recommended and when required. Follow load restraint guidelines to secure your load and practice road safety at all times."
  public selectedConnote     = [];
  public selectCarrier       = null;
  public driverIndex         = null;

  //main listings
  public carrierList          = []; //get only drivers with pairs
  public maincarrierList      = [];
  public consignmentsList     = []; //get only local connotes
  public mainconsignmentsList = []; 
  public manifestList         = []; //get only local manifests
  public mainManifestList     = [];

  public consignmentSpinner: boolean = false;
  public carrierSpinner: boolean     = false;
  public manifestSpinner: boolean    = false;

  //Misc data declerations
  public routes              = []
  public run_actions         = [];
  public run_types           = [];
  public locations           = [];
  public service_types       = [];
  public states              = [];
  public run_statuses        = [];
  public wh_sites            = [];
  public packaging_types     = [];
  public dg_licenses         = [];
  public dg_subsidiary_risks = [];
  public geofence_size_default: number = 0;

  public driverPairings    = [];
  public connotesListing   = [];

  public admin_user         = this.user.id;
  public runPlanActivities  : any;
  public fleetTypes         : [];
  public list1Spinner       : boolean = false;
  public list2Spinner       : boolean = false;
  public list3Spinner       : boolean = false;

  //filters
  private dateStatusFilter  : string = 'current';
  public dateFilter         : string = 'today';
	public jobDateRange       : any = [];
  public dateRangeStart     : string = '';
  public dateRangeEnd       : string = '';

  singleDate = false;

  public geofence: GeofenceRadius = {
    "run_index": null,
    'phase_index': null,
    "site_index": null,
    "radius" : this.geofence_size_default,
    "created_by" : this.admin_user.toString()
  }
  driverStandards: any;
  
  // Icon Checker
  public hasConsignmentLeft = false;

  // Date Ahead/Behind Checker
  duration = 0;

  // Cancel Dispatched Job
  returnConsignmentIndex = null;
  returningConnoteList = [];
  isReturnedConsignment = false;

  connoteConflicts = {
    'driver_index': null,
    'driver': '',
    'driverInfo': null,
    'equipment': '',
    'service_type': '',
    'connotes': [],
    'completeConnotes': [],
  } 

  initFilterForm() {
    this.filterForm = this.fb.group({
      //consignment
      connote_controlNo      : [''],
      connote_customer       : [''],
      connote_referenceNo    : [''],
      connote_orderType      : ['All'],
      connote_warehouse      : ['0'],
      connote_serviceType    : [''],

      //manifest
      manifest_controlNo     : [''],
      manifest_customer      : [''],
      manifest_orderType     : ['All'],
      manifest_warehouse     : ['0'],
      manifest_status        : ['1'],

      //carrier
      carrier_name           : [''],
      carrier_controlNo      : [''],
      carrier_equipment      : [''],
      carrier_hasJob         : ['All'], //with or without job
      carrier_orderType      : ['All'],
      carrier_warehouse      : ['0'],
      carrier_DrvStandard    : ['0'],
    });
  }

  public modalRef: NgbModalRef;
  @ViewChild('editConsignments', { static: false }) editConsignments: TemplateRef<any>;
  currentDate = new Date();
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd mmm yyyy',
    height: '25px',
    selectionTxtFontSize: '13px',
    showTodayBtn: true,
    disableUntil: {year: this.currentDate.getFullYear(), month: this.currentDate.getMonth()+1, day: this.currentDate.getDate()-1}
  };

  editConsignmentForm: FormGroup;
  origConsignmentsList = [];
  public countCheckedConnotes = 0;

  minDate: any;

  // filter modals
  panelModal = '';
  @ViewChild('filterModal', { static: false }) filterModal: TemplateRef<any>;
  @ViewChild('checkEquipmentModal', { static: false }) checkEquipmentModal: TemplateRef<any>;


  constructor(private localDispatchService: LocalDispatchService, private dispatchService: DispatchService,  private driverService: DriversService,
              private fleetpairingService: FleetPairingService, private driverTruckPairingService: DriverTruckPairingService,
              private dragulaService: DragulaService, private toastr: ToastrService, private router: Router, private modal: NgbModal, private fb: FormBuilder,
              private svc_components : ComponentsSettingsService) {

    this.dragulaService.dropModel("CONSIGNMENT").subscribe(({ item, source, target, targetIndex }) => { 
      this.movedItems.push(item);

      // Check returning dispatched job
      if(source.attributes[0].value === "carrierContentData" && (target.attributes[0].value === "consignmentData")){
        this.returningConnoteList.push(item);
        this.returnConsignmentIndex = targetIndex;
      }
    });
    
    // Handle display of multiple selected consignment items
    this.dragulaService.cloned("CONSIGNMENT").subscribe(({ clone, original, cloneType }) => {
      // Set to only display selected items upon dragging
      this.mirrorContainer = $('.gu-mirror').first();
      this.mirrorContainer.removeClass('ex-over');
  
      this.selectedItems = $('.ex-over');   // Get items with .ex-over class
  
      // Set boolean for multiple selected consignments
      this.hasMultiple = this.selectedItems.length > 1 || (this.selectedItems.length == 1 && !$(original).hasClass('ex-over'));
  
      if (this.hasMultiple) {
        $('.gu-transit').addClass('ex-over');
        this.selectedItems = $('.ex-over');
        this.mirrorContainer.empty();

        let temp = this.mirrorContainer;
        this.selectedItems.each(function () {
          var item = $(this);
          var mirror = item.clone(true);
          mirror.removeClass('ex-over gu-transit');
          temp.append(mirror);
          temp.css('background-color', 'transparent');
        });
        this.mirrorContainer = temp;
      }
    });
    
    this.dragulaService.drop("CONSIGNMENT").subscribe(({ el, source, target }) => {
      this.selectCarrier = target.parentElement.id;   // Assign arrray's index of driver

      // Checks dragging of consignment and carrier's consignment items
      if (source.attributes[0].value === "consignmentData" && (target.attributes[0].value === "carrierContentData")) { // from consignment to carrier
        if (!this.hasMultiple){
          let target = document.getElementsByClassName('target-carrier');
          for (let i = target.length - 1; i >= 0; i--) {
            if (target[i].className.includes('ex-over') && i >= 0) {
              this.removeClass(target[i], 'ex-over');
            }
          }
          this.selectedConnote = this.movedItems;
        }else{
          el.remove();
          this.moveto();
        }

        for (let i = 0; i < this.carrierList.length; i++) {
          this.carrierList[i].is_checked = false;
        }

        this.dropConsignment(this.selectedConnote, this.selectCarrier);
      }else if(source.attributes[0].value === "carrierContentData" && (target.attributes[0].value === "consignmentData")){ // from carrier to consignment

        let run_id = this.movedItems[0].run_id
        if (!this.hasMultiple) {
          let target = document.getElementsByClassName('target-consignment');
          this.moveback(this.movedItems, run_id);

          for (let i = target.length - 1; i >= 0; i--) {
            if (target[i].className.includes('ex-over') && i >= 0) {
              this.removeClass(target[i], 'ex-over');
            }
          }
        } 
      }

      // Check consignments left
      this.connotesListing.length > 0 ? this.hasConsignmentLeft = true : this.hasConsignmentLeft = false; 
      
    });

    // Prevents an item in the BOOKING_LIST to be moved with .card-dashed class
    this.dragulaService.createGroup('CONSIGNMENT', {
      moves: (el) => !el.classList.contains('card-dashed') && !el.classList.contains('card-disable')
    });
  }

  isEditConsignmentDone = false;
  invalidDate = [];
  async ngOnInit(): Promise<void> {
    this.minDate = new Date().toLocaleString();
    this.initFilterForm();
    await this.getData();
    await this.getActivities();
    await this.getPairing();
    await this.getAllRuns();
    await this.getDriverStandards();

    this.editConsignmentForm = this.fb.group({
      editConsignmentList: this.fb.array([])
    });

    this.editConsignmentForm.valueChanges.subscribe((data)=>{
      let editedConsignmentList = data.editConsignmentList;
      let editConsignmentDoneCount = 0;
      this.countCheckedConnotes = 0;
      editedConsignmentList.forEach((connote,index)=>{
        if(connote.checkDone == true){
          editConsignmentDoneCount+=1;
          this.countCheckedConnotes+=1;
        }
        if(connote.editConsignmentDate != null && connote.editConsignmentDate != ""){
          let site_error = 0;
          for (let i = 0; i < connote.editConsignmentTimeList.length; i++) {
             if(i>0){
              if(this.getEditedTime(connote.editConsignmentTimeList[i].editConsignmentTime) <= this.getEditedTime(connote.editConsignmentTimeList[i-1].editConsignmentTime)){
                site_error = site_error + 1;
              }
             }
          }
          if(site_error > 0){
            if(!this.invalidDate.includes(index)){
              this.invalidDate.push(index);
            } 
          }
          else{
            if(this.invalidDate.includes(index)){
              this.invalidDate.splice(this.invalidDate.indexOf(index), 1);
            }
          }
        }
        else{
          if(!this.invalidDate.includes(index)){
            this.invalidDate.push(index);
          } 
        }
      });
      this.isEditConsignmentDone = (editConsignmentDoneCount > 0) ? true : false; 
    });
  }

  getEditedTime(timeString){
    const timeValue = timeString;
    const [hours, minutes] = timeValue.split(':').map(Number);
    const inputTime = new Date();
    inputTime.setHours(hours, minutes, 0, 0);
    return inputTime;
  }

  initEditConsignmentForm(){
    this.connotes_toCheck.forEach((connote)=>{
      this.addItemToFormArray(connote);
    });
  }

   // Use this function as trackBy in ngFor of Carrier's panel
   trackByFn(index: number, carrier) {
    return carrier.id; // Or any unique identifier of the carrier
  }

  addItemToFormArray(connote) {
    const newFormControl = this.fb.group({
      id: [connote.id],
      checkDone: [false],
      editConsignmentDate: [this.currentDate.getFullYear()+'-'+String(this.currentDate.getMonth()+1).padStart(2,'0')+'-'+String(this.currentDate.getDate()).padStart(2,'0')],
      editConsignmentTimeList: this.fb.array([]) 
    });

    connote.connote_sites.forEach(
      (site)=>{
        const timeString = site.opening_datetime.split(" ");
        (newFormControl.get('editConsignmentTimeList') as FormArray).push(this.fb.group({editConsignmentTime: [timeString[timeString.length-1]]}));
      }
    );
    (this.editConsignmentForm.get('editConsignmentList') as FormArray).push(newFormControl);
  }

  toggleCalendar(){
    let datePicker = document.querySelector('div.ltr');

    if(datePicker!=null){
      if(datePicker.classList.contains('shown')){
        datePicker.classList.remove('shown');
        datePicker.classList.add('hidden');
      }
    }
  }

  toggleSingleDatePicker(){
    let datePicker = document.querySelector('div.ltr');
    let dateRangeLabel = document.querySelector('option#date_range_label');

    if(this.singleDate==true){
      this.singleDate=false;
      this.dateFilter='';
      dateRangeLabel.innerHTML = 'Custom date range';
      
      if(datePicker!=null){
        if(datePicker.classList.contains('shown')){
          datePicker.classList.remove('shown');
          datePicker.classList.add('hidden');
        }
      }
    }
    else{
      this.singleDate=true;
      this.dateFilter='range';
      dateRangeLabel.innerHTML = 'Custom date';

      if(datePicker!=null){
        if(datePicker.classList.contains('hidden')){
          datePicker.classList.remove('hidden');
          datePicker.classList.add('shown');
        }
      }
    }
  }

  toggleDateRangePicker(){
    if(this.dateFilter=='range' && this.singleDate==false) return true;
    else return false;
  }

  // View Manifest in a new tab
  viewManifest(id){
    if(this.isEnabled('Local Manifest')){
      const openIn = this.router.serializeUrl(
        this.router.createUrlTree(['/dispatch/manifestdetails/', id ])
      );
      window.open(openIn, '_blank');
    }
  }

  // View Driver's details in a new tab
  viewDriver(carrierID){
    if(this.isEnabled('Drivers')){
      const openIn = this.router.serializeUrl(
        this.router.createUrlTree(['/drivers/driverslist/driverdetails', {id: carrierID} ])
      );
      window.open(openIn, '_blank');
    }
  }

   //get needed data
   async getData() {
    console.time('Loading Time: ')
    await this.dispatchService.getDispatchMiscData().toPromise().then(data => {
      this.service_types          = data['service_types'];
      this.run_actions            = data['run_actions'];
      this.run_types              = data['run_types'];
      this.states                 = data['states'];
      this.routes                 = data['state_routes'];
      this.run_statuses           = data['run_statuses'];
      this.wh_sites               = data['warehouse_sites'];
      this.packaging_types        = data['packaging_types'];
      this.dg_licenses            = data['dg_licenses'];
      this.dg_subsidiary_risks    = data['dg_subsidiary_risks'];
      this.geofence_size_default  = data['geofence_default'];
    })
  }

  public getDriverStandards() {
    this.driverService.getDriverStandards().subscribe(data => {
      this.driverStandards = data["standards"];
    })
  }

  async getActivities() {
    await this.localDispatchService.getTasksWithoutRunLocalv2().toPromise().then(data => {
      this.runPlanActivities = data['new_tasks_without_run'];
    })

    await this.dispatchService.getActivitiesv3(this.job_Type).toPromise().then(data => {
      this.connotesListing = data['connotes'];

      this.connotesListing.forEach(con => {
        let temp = this.runPlanActivities.filter(x => x.connote_id == con.id)

        if(con.service_type_id != null){
          con['service_type'] = this.service_types.find(x=> x.id == con.service_type_id).name;
        }

        if(temp.length > 0){
          temp.forEach(act => {
            let site = con.connote_sites.find(x=>x.id == act.plan_connote_site_id && x.run_action_id == act.run_action_id)
            if(site != undefined){
              con.connote_sites.splice(con.connote_sites.findIndex(x=>x.id == site.id), 1, act)
            } else con.connote_sites.push(act);
          });

          let first = [], last = []
          con.connote_sites.forEach(act => {
            if(act.run_action_id == 1 || act.run_action_id == 10){
              first.push(act)
            } else if(act.run_action_id == 2|| act.run_action_id == 9){
              last.push(act)
            }            
          });

          let final = [...first, ...last];
          con['connote_sites'] = final;    
        }
      });

      // Check there are consignments left
      if(this.connotesListing.length > 0){
        this.hasConsignmentLeft = true;
        this.connotesListing = this.connotesListing.filter((x)=>{
          if(x['connote_sites'].length != 0 && x['connote_sites'].find(y=>y.run_action_id == 5) == undefined){
            return x;
          }
        })
        console.log('booked connotes available: ', this.connotesListing?.length); //final connoteslist 

        // Compute number of days passed of each consignments
        this.connotesListing.forEach(con => {
          con['computed_days_on_sched'] = false;
          con['computed_days_desc'] = '';
          con['duration'] = 0;

          let start = moment(Date.now());
          if(con.connote_sites != undefined){
            let curr_date = moment(con.connote_sites[0].opening_datetime).toDate();
            let end = moment(curr_date);
        
            let duration = 0;
            duration = start.diff(end, 'days'); 

            if( duration > 0){   // Check date is behind
              con['computed_days_on_sched']  = true;
              if(duration < 2){
                con['duration'] = duration;
                con['computed_days_desc'] = "This is " + duration + " day behind schedule!";
              }else{
                con['duration'] = duration;
                con['computed_days_desc'] = "This is " + duration + " days behind schedule!";
              }
            }else if(duration < 0){ // Check date is ahead
              con['duration'] = duration;
              con['computed_days_on_sched']  = true;
              con['computed_days_desc'] = "Dispatch on or before " + moment(con.connote_sites[0].opening_datetime).format('DD MMM YYYY');
            }else{
              con['duration'] = duration;
              con['computed_days_on_sched']  = false;
              con['computed_days_desc'] = "Dispatch " + con.control_no + " right away!"
            }
          }
        });

        this.mainconsignmentsList = this.connotesListing;
        this.origConsignmentsList = [...this.mainconsignmentsList]; //get a copy of connote list
        this.panelModal = 'consignment'; this.resetFilters('consignment');
      } else{
        console.log('no connotes booked.')
        this.hasConsignmentLeft = false;
      } 
    }).finally(() =>{
        this.loadConsignmentSpinner = false; //turn off consignment spinning icon
    });
  }

  getPairing(){
    // Reset list after reloading...
    this.carrierList = [];

    this.driverTruckPairingService.getPairsv2().subscribe(data=>{
      let fleet_drivers: any = [];
      fleet_drivers = data;

      this.carrierList = [];

      fleet_drivers.forEach(pair => {
          // Set status of carrier from all tasks to do
          let inTransitCount = 0, completedCount = 0;
          pair['full_job_status'] = ''
          pair['full_job_status_desc'] = ''
  
          for(let j=0; j < pair.assignedConnotes.length; j++){
            if(pair.assignedConnotes[j].run_status_id == 3){
              inTransitCount+=1;
            }else if(pair.assignedConnotes[j].run_status_id == 4){
              completedCount+=1;
            }
          }
  
          if(inTransitCount > 0){
            pair['full_job_status'] = pair.currentManifest_controlno;
            pair['full_job_status_desc'] = 'Some consignments are being transported!';
          }else if(completedCount == pair.assignedConnotes.length){
            pair['full_job_status'] = pair.currentManifest_controlno;
            pair['full_job_status_desc'] = 'All consignments are delivered to their destination';
          }else{
            pair['full_job_status'] =  pair.currentManifest_controlno;
            pair['full_job_status_desc'] = 'All consignments are not moving';
          }

          pair.assignedConnotes.map(x=>{
            let new_pair = x;
            let acts = pair.assignedSite.filter(y=>{ return y.connote_id === new_pair.id });
            new_pair['activities'] = acts;
            new_pair['run_id'] = pair.currentManifest_id;
            new_pair['hasActivitiesDone'] = this.checkActivities(acts);
            return new_pair;
          });

          pair['is_dispatching'] = false;
          pair['is_updating'] = false;
          pair['is_checked'] = false;
          this.carrierList.push(pair);
      });

      this.maincarrierList = this.carrierList;
      this.panelModal = 'carrier'; this.resetFilters('carrier');
      this.loadCarrierSpinner = false; //turn off Carrier spinner
      // console.log('available carriers ', this.carrierList)//final driverlist!
    });
}

  // async getPairing(){
  //   let d_list = [], f_list = [], pair_list = []; 
  //   await this.driverTruckPairingService.getPairs({perPage:-1}).toPromise().then(async data => {
  //     pair_list = data;
  //     await this.dispatchService.getEquipments().toPromise().then(data => {
  //       f_list = data["equipments"];
  //     });

  //     await this.dispatchService.getDrivers().toPromise().then(data => {
  //       d_list = data["drivers"];
  //     });
  //   });
  //   this.getCarriers(d_list, f_list, pair_list);
  // }

  // getCarriers(d_list, f_list, pair_list){
  //   // Reset list after reloading...
  //   this.carrierList = [];

  //   pair_list.forEach(pair => {
  //     let drv = d_list.find(x=>x.id == pair.driver_id)
  //     let equipment = []
  //    if(drv !=undefined){
  //       // Set status of carrier from all tasks to do
  //       let inTransitCount = 0, completedCount = 0;
  //       drv['full_job_status'] = ''
  //       drv['full_job_status_desc'] = ''

  //       for(let j=0; j < drv.assignedConnotes.length; j++){
  //         if(drv.assignedConnotes[j].run_status_id == 3){
  //           inTransitCount+=1;
  //         }else if(drv.assignedConnotes[j].run_status_id == 4){
  //           completedCount+=1;
  //         }
  //       }

  //       if(inTransitCount > 0){
  //         drv['full_job_status'] = drv.currentManifest_controlno;
  //         drv['full_job_status_desc'] = 'Some consignments are being transported!';
  //       }else if(completedCount == drv.assignedConnotes.length){
  //         drv['full_job_status'] =  drv.currentManifest_controlno;
  //         drv['full_job_status_desc'] = 'All consignments are delivered to their destination';
  //       }else{
  //         drv['full_job_status'] =  drv.currentManifest_controlno;
  //         drv['full_job_status_desc'] = 'All consignments are not moving';
  //       }

  //       drv['paired'] = true;
  //       let flt = f_list.find(x=>x.id == pair.fleet_id);
      
  //       if(flt !=undefined){
  //         equipment.push(flt)
          
  //         //add fleet pair check
  //         //if pm, search for paired trailer
  //         //no truck trailer pairing atm
          
  //       } else drv['equipment'] = null;

  //       if(drv['paired'] && equipment.length > 0){
  //         drv.assignedConnotes.map(x=>{
  //           let new_x = x;
  //           let acts = drv.assignedSite.filter(y=>{ return y.connote_id == new_x.id});
  //           new_x['activities'] = acts 
  //           new_x['run_id'] = drv.currentManifest_id;
  //           new_x['hasActivitiesDone'] = this.checkActivities(acts);
  //           return new_x;
  //         });
  //         drv['equipment'] = equipment;
  //         drv['is_dispatching'] = false;
  //         drv['is_updating'] = false;
  //         drv['is_checked'] = false;
  //         this.carrierList.push(drv);
  //       }
  //     }
  //   });
  //   this.maincarrierList = this.carrierList;
  //   this.panelModal = 'carrier'; this.resetFilters('carrier');
  //   this.loadCarrierSpinner = false; //turn off Carrier spinner
  //   console.log('available carriers ', this.carrierList)//final driverlist!
  // }

  async getAllRuns(statusFilter = this.dateStatusFilter, dateFilter = this.dateFilter, start = this.dateRangeStart, end = this.dateRangeEnd){
    console.time('Getting runs');
    this.loadManifestSpinner = true;
		await this.localDispatchService.getRunsLocal(statusFilter, dateFilter, start, end).toPromise().then(data => {
      // console.log('ongoing runs today ', data) //final manifestlist!
      this.manifestList = data;
      if(this.manifestList.length != 0){
        this.manifestList.forEach(el => {
          // Get corresponding activities of the connote
          for(let i=0; i<el.connotes.length; i++){
            el.connotes[i].activities=[];

            for(let j=0; j<el.activities.length;j++){
              if(el.activities[j].connote_id == el.connotes[i].id){
                // Store the activities in the related connote
                el.connotes[i].activities.push(el.activities[j]);
              }
            }
            el.connotes[i].hasActivitiesDone = this.checkActivities(el.connotes[i].activities);
          }
        });
        this.mainManifestList = data;
        this.panelModal = 'manifest';  this.resetFilters('manifest');
        this.manifestList = this.filteredDataManifest // filter
      }
    }).finally(()=>{
      this.loadManifestSpinner = false; //turn off manifest spinner
    });
    console.timeEnd('Getting runs');
  }

  public formatDate(inDate: string) {
    let formatedDate: Date;
		if (inDate && !inDate.includes('0000') ) {
			formatedDate = new Date(inDate.replace(/-/g, "/"));
			return formatedDate;
		}
		else return null;
	}

  public getFullAdress(type, activities){
    let string = '';

    if(activities == undefined){ //temp fix to avoid error if connote has no activities
      string = 'No location found' 
    }else{
      if(type == 'start'){
        let act = activities[0];
        if(act.location_id){
          act.street_no != null ? string = act.street_no + ' ' : string = '';
          act.street != null ? string = string + act.street + ', ' : string += '';
         ( act.suburb != null || act.suburb != '' )? string = string + act.suburb + ', ': string = string + act.city + ' ';
          act.state_abbrev != null ? string = string + act.state_abbrev + ' ': string += ' ';
        } else string = 'Location to be determined';
      }
      if(type == 'end'){
        let act = activities[activities.length-1]
        if(act.location_id){
          act.street_no != null ? string = act.street_no + ' ' : string = '';
          act.street != null ? string = string + act.street + ', ' : string += '';
          act.suburb != null || act.suburb != '' ? string = string + act.suburb + ', ': string = string + act.city + ' ';
          act.state_abbrev != null ? string = string + act.state_abbrev + ' ': string += ' ';
        } else string = 'Location to be determined';
      }
    }
    return string;
  }

  connotes_toCheck = [];
  public async dropConsignment(connote, carrierIndex){
    console.log('selected connotes', connote);
    console.log('selected driver', carrierIndex);

    if(this.connotesListing.find(x=>x.id == connote.id) == undefined){  // Check connote upon assigning to carrier
        connote.forEach(element => {
          let indx = this.mainconsignmentsList.findIndex(x=>x.id == element.id);
          this.mainconsignmentsList.splice(indx,1);

          //include connotes with current/past/different dates in the list of connotes to check
          let diff_dates = false;
          let dates = [];
          element.connote_sites.forEach((c_site)=>{
            let date = moment(c_site.opening_datetime).format('YYYY-MM-DD');
            if(!dates.includes(date)) dates.push(date);
          });

          diff_dates = (dates.length > 1) ? true : false;

          if(diff_dates){
            let check_connote = this.connotes_toCheck.findIndex(x=>x.id==element.id);
            if(check_connote == -1) this.connotes_toCheck.push(element);
          }
          else{
            let today = moment().format('YYYY-MM-DD 00:00:00');
            if(moment(element.connote_sites[0].opening_datetime).format('YYYY-MM-DD 00:00:00') <= today){ //include past and current dated connotes in the list of connotes to check
              let check_connote = this.connotes_toCheck.findIndex(x=>x.id==element.id);
              if(check_connote == -1) this.connotes_toCheck.push(element);
            }
          }
           
        });

        // Check driver's index exist
        if(carrierIndex != ''){
          if('is_updating' in this.carrierList[carrierIndex] == false){ // Check object doesn't exist
            console.log("is_updating not existing");
            this.carrierList[carrierIndex] = {
              is_updating: false
            };
          }
          this.carrierList[carrierIndex]?.assignedConnotes.length < 2 ? this.carrierList[carrierIndex].is_dispatching = true :  this.carrierList[carrierIndex].is_updating = true;  

        if(this.connotes_toCheck.length > 0){
          console.log('connotes to check', this.connotes_toCheck);
          this.initEditConsignmentForm();
          this.modalRef = this.modal.open(this.editConsignments, { size: 'lg', backdrop: 'static', centered: true });
        }
        else{
          console.log('connotes to dispatch', connote);
          await this.queueDispatch(connote, this.carrierList[carrierIndex], carrierIndex);
        }
        
        // // Check driver's index exist
        // if(carrierIndex != ''){
        //   if('is_updating' in this.carrierList[carrierIndex] == false){ // Check object doesn't exist
        //     console.log("is_updating not existing");
        //     this.carrierList[carrierIndex] = {
        //       is_updating: false
        //     };
        //   }
        //   this.carrierList[carrierIndex]?.assignedConnotes.length < 2 ? this.carrierList[carrierIndex].is_dispatching = true :  this.carrierList[carrierIndex].is_updating = true;  
          
          // await this.queueDispatch(connote, this.carrierList[carrierIndex], carrierIndex);
        }
      // }
    } 
  }

  cancelDispatch(){
    this.modalRef.close();

    let connote_toRemove = [];
    this.carrierList[this.selectCarrier].assignedConnotes.forEach((connote, index)=>{
      if(!connote.hasOwnProperty('activities')) connote_toRemove.push(index);
    });

    connote_toRemove.forEach((index)=>{
      this.carrierList[this.selectCarrier].assignedConnotes.splice(index,1);
    });

    this.carrierList[this.selectCarrier].is_updating = false;
    this.carrierList[this.selectCarrier].is_dispatching = false;

    this.loadConsignmentSpinner = true;
    this.connotesListing = this.origConsignmentsList;
    this.loadConsignmentSpinner = false;

    this.resetEditConsignments();
  }

  public async saveEditedConsignments(){
    let connotes_toDispatch = this.selectedConnote;

    this.editConsignmentForm.value.editConsignmentList.forEach((group)=>{
      if(group.checkDone == true){ //if checked by the user
        let i = connotes_toDispatch.findIndex(x=>x.id==group.id);

        //change connote schedule
        connotes_toDispatch[i].connote_sites.forEach((c_site, index)=>{
          // let hour = moment(c_site.opening_datetime).format("HH:mm:00");
          // let new_date = new Date(group.editConsignmentDate.date.year,group.editConsignmentDate.date.month-1,group.editConsignmentDate.date.day); //date entered by the user
          // c_site.opening_datetime = moment(new_date).format('YYYY-MM-DD')+' '+hour;
          // c_site.closing_datetime = moment(new_date).format('YYYY-MM-DD')+' '+hour;
          c_site.opening_datetime = group.editConsignmentDate+' '+group.editConsignmentTimeList[index].editConsignmentTime;
          c_site.closing_datetime = group.editConsignmentDate+' '+group.editConsignmentTimeList[index].editConsignmentTime;
        });

        i = this.origConsignmentsList.findIndex(x=>x.id==group.id);
        this.origConsignmentsList.splice(i,1);
      }
      else{
        let i = this.selectedConnote.findIndex(x=>x.id==group.id);
        connotes_toDispatch.splice(i,1);
      }
    });

    //remove the connotes from the consignment panel
    connotes_toDispatch.forEach((connote)=>{
      let i = this.origConsignmentsList.findIndex(x=>x.id==connote.id);
      if(i != -1) this.origConsignmentsList.splice(i,1);
    });

    this.modalRef.close();
    this.loadConsignmentSpinner = true;
    this.connotesListing = this.origConsignmentsList; 
    this.loadConsignmentSpinner = false;

    console.log('connotes to dispatch', connotes_toDispatch);
    await this.queueDispatch(connotes_toDispatch, this.carrierList[this.selectCarrier], this.selectCarrier);
    this.resetEditConsignments();
  }

  resetEditConsignments(){
    this.editConsignmentForm.controls.editConsignmentList['controls'] = [];
    this.editConsignmentForm.value.editConsignmentList = [];

    this.connotes_toCheck = [];
    this.selectedConnote = [];
    this.movedItems = [];
    this.isEditConsignmentDone = false;
  }

  public async queueDispatch(connote, carrier, carrierIndex){
    await this.assignConsignment(connote, carrier, carrierIndex);
  }

  //submit functions
   public async assignConsignment(connote, carrier, carrierIndex){ //call function when connote is dragged to carrier
    let tba = 0;
    let finalRun_test = { 'runs': {
      'run':[], 'changeover':[], }   ,'trigger' :'local-dispatch'
    }
    
      // if(carrier.currentManifest_id != null){
      //   console.log('Adding consignment');
      //   let final_data = await this.getFinalData(connote, carrier);

      //   let arr = {
      //     "activities": final_data['activities'],
      //     "driver_id": carrier.id,
      //     "run_id": carrier.currentManifest_id,
      //     "admin_id": this.admin_user,
      //   }

      //   // Immediate reset of selected items for reuse array allocation
      //   this.selectedConnote = [];
      //   this.movedItems = [];
      //   await this.localDispatchService.updateRunsLocal(arr).toPromise().then(async data => {
      //     if (data['error'] == false) {
      //       this.toastr.success('', data['message'], {
      //         timeOut: 3000, positionClass: 'toast-top-right', progressBar: true
      //       });
      //       await this.getPairing();
      //       await this.getAllRuns();
      //     } 
      //   }).catch(data =>{
      //     if(data['error_message'] == null){
      //       this.toastr.error('Please try again', 'There was a problem upon updating your dispatch.', {
      //         timeOut: 4000, positionClass: 'toast-top-right', progressBar: true
      //       });
      //     }else if(data['error_message'] == ' '){
      //       this.toastr.error('Please try again', 'There was a problem upon updating your dispatch.', {
      //         timeOut: 4000, positionClass: 'toast-top-right', progressBar: true
      //       });
      //     }else{
      //       this.toastr.error('Please try again', data["error_message"], {
      //         timeOut: 4000, positionClass: 'toast-top-right', progressBar: true
      //       });
      //     }
      //     this.loadDispatchingConsignment = false;
      //   }).finally(()=>{
      //     this.loadDispatchingConsignment = false;
      //     this.getActivities();
      //   });
      
      // } else {

        let data = await this.getFinalData(connote, carrier);  // Set activities, drivers, and equipments
        let route_id = (connote[0].run_type_id == 1)? null : await this.autoSetLocation(connote[0].connote_sites); 
        
        (data['tba_count'] > 0)? tba = 1: tba = 0;

        var dispatchData: Run = {
          id                      : null,
          uuid                    : null,
          control_no              : connote.length > 1 ? '' : connote[0].control_no,
          run_type_id             : connote[0].run_type_id,
          service_type_id         : this.getFinalServiceType(carrier.equipment),
          linehaul_type           : '1',
          activities              : data['activities'],
          equipments              : data['equipments'],
          drivers                 : data['drivers'],
          is_released             : 0,
          has_tba                 : tba,
          run_routes_id           : route_id,
          total_klms              : 0, //
          total_driving_hours     : 0, // computations transfered to backend
          total_work_hours        : 0, //
          other_work_hours        : 1.50, //default
          min_long_rest_hours     : 0, //
          min_short_rest_hours    : 0, // computations transfered to backend
          other_rest_hours        : 0, //
          departure_date          : formatDate(connote[0].connote_sites[0].closing_datetime, 'yyy-MM-dd', 'en-US'),
          departure_time          : formatDate(connote[0].connote_sites[0].closing_datetime, 'HH:mm:ss', 'en-US'),
          arrival_date            : formatDate(connote[0].connote_sites[0].closing_datetime, 'yyy-MM-dd', 'en-US'),
          arrival_time            : formatDate(connote[0].connote_sites[0].closing_datetime, 'yyy-MM-dd', 'en-US'),
          is_excluded_saturday    : 1,
          is_excluded_sunday      : 1,
          is_excluded_holiday_no  : 0,
          excluded_holiday_dates  : null,
          run_status_id           : 1,
          admin_notes             : '',
          driver_notes            : '',
          dispatch_notes          : this.dispatchNotes,
          created_by              : this.admin_user,
          updated_by              : null,
          created_at              : '',
          updated_at              : '',
          changeover_run_id       : '',
          finish_done             : false
        }
        finalRun_test.runs.run.push(dispatchData);

        // Immediate reset of selected items for reuse array allocation
        this.selectedConnote = [];
        this.movedItems = [];

        await this.localDispatchService.createRunsLocal(finalRun_test).toPromise().then( async data => {
          if (data['error'] == false) {
            this.toastr.success('', data['message'], {
              timeOut: 3000, positionClass: 'toast-top-right', progressBar: true
            });
            await this.getPairing();
            await this.getAllRuns();
          } 
        }).catch(data =>{
          if(data['error_message'] == null){
            this.toastr.error('Please try again', 'There was a problem upon your dispatch.', {
              timeOut: 4000, positionClass: 'toast-top-right', progressBar: true
            });
          }else if(data['error_message'] == ' '){
            this.toastr.error('Please try again', 'There was a problem upon your dispatch.', {
              timeOut: 4000, positionClass: 'toast-top-right', progressBar: true
            });
          }else{
            this.toastr.error('Please try again', data["error_message"], {
              timeOut: 4000, positionClass: 'toast-top-right', progressBar: true
            });
          }
          this.loadDispatchingConsignment = false;
        }).finally(async ()=>{
          this.loadDispatchingConsignment = false;
          await this.getActivities();
        });
        
      // }
  }

  getFinalData(connote, carrier){
    this.loadDispatchingConsignment = true; //turn on spinner upon dispatching
    let fleet = carrier.equipment
    let drivers = [], equipments = [], activities = []
    
    //driver
    let temp: RunDriver = {
      id            : null,
      driver_id     : carrier.id,
      run_event_id  : null,
      run_id        : null,
      is_two_up     : 0, //1 driver only in local dispatch case
      is_active     : 1,
      created_at    : '',
      updated_at    : '',
      is_planned    : 1,
      is_changeover : 0,
    }
    drivers.push(temp);
    
    //fleet
    let count = 1; //trailer count
    fleet.forEach(eq => { // error here because carrier.equipment is not array thus not iterable
      if(eq.is_truck = 1){
        let temp: RunEquipment = {
          id            : null,
          run_id        : null,
          equipment_id  : eq.id,
          run_event_id  : null,
          gross_weight  : null,
          axle1         : null,
          axle2         : null,
          axle3         : null,
          axle4         : null,
          axle5         : null,
          axle6         : null,
          axle7         : null,
          is_active     : 1,
          created_at    : '',
          updated_at    : '',
          is_planned    : 1,
          is_changeover : 0,
          is_trailer    : 0,
          is_truck      : 1,
          trailer_order_number: 0,
          phase_order_number : 1
        }
        equipments.push(temp)

      } else {
        
        let temp: RunEquipment = {
          id            : null,
          run_id        : null,
          equipment_id  : eq.id,
          run_event_id  : null,
          gross_weight  : null,
          axle1         : null,
          axle2         : null,
          axle3         : null,
          axle4         : null,
          axle5         : null,
          axle6         : null,
          axle7         : null,
          is_active     : 1,
          created_at    : '',
          updated_at    : '',
          is_planned    : 1,
          is_changeover : 0,
          is_trailer    : 0,
          is_truck      : 1,
          trailer_order_number: count,
          phase_order_number : 1
        }
        count++;
        equipments.push(temp)
      }
    });
    
    //activities
    let act_count = 1, tba_count = 0;
    let data, finalActivities = [];
    for(let i=0; i<connote.length; i++){
      // Set all activities to an array
      connote[i].connote_sites.forEach((act) => {
        if(act.location_id == null) tba_count++;
        // //if date time != today [update]
        // let update_date = new Date();
        // if((formatDate(act.opening_datetime,'yyyy-MM-dd','en_US') < formatDate(update_date,'yyyy-MM-dd','en_US')) ||
        // (formatDate(act.opening_datetime,'yyyy-MM-dd','en_US') > formatDate(update_date,'yyyy-MM-dd','en_US'))){
        //   //update time if already passed
        //   act.opening_datetime = formatDate(update_date,'yyyy-MM-dd hh:mm:ss','en_US');
        //   act.closing_datetime = formatDate(update_date,'yyyy-MM-dd hh:mm:ss','en_US');
        // }
          //if date < today [update]

          // let current_date = new Date();
          // if((formatDate(act.opening_datetime,'yyyy-MM-dd','en_US') < formatDate(current_date,'yyyy-MM-dd','en_US'))){
          //   let update_date = moment().format('YYYY-MM-DD');
          //   act.opening_datetime = update_date+' '+moment(act.opening_datetime).format('HH:mm:ss');
          //   act.closing_datetime = update_date+' '+moment(act.closing_datetime).format('HH:mm:ss');
          // }

        let temp: RunPlanActivity = {
          id              : (act.plan_id)? act.plan_id :null,
          run_id          : null,
          connote_id      : act.connote_id,
          run_action_id   : act.run_action_id,
          connote_site_id : (act.plan_id)? act.plan_connote_site_id: act.id,
          order_number    : act_count,
          location_id     : act.location_id,
          start_datetime  : act.opening_datetime,
          end_datetime    : act.closing_datetime,
          created_by      : this.admin_user,
          updated_by      : null,
          created_at      : '',
          updated_at      : '',
          connote_site    : null,
          geofence        : this.geofence,
          phase_order_number : 1
        }
          activities.push(temp);
          act_count++;
      });     
    }
    return {drivers, equipments, activities, tba_count}
  }

  async removeConnote(connotes, run_id){
    // Immediate reset of selected items for reuse array allocation
    this.selectedConnote = [];
    this.movedItems = [];
    this.isReturnedConsignment = true;
    
    await this.localDispatchService.removeConnote(connotes, run_id, this.admin_user).toPromise().then(async data => {
      if(!data['error']){
        this.isReturnedConsignment = true;
        this.toastr.success(data['error_message'],'' , {
          timeOut: 4000, positionClass: 'toast-top-right', progressBar: true
        });

        if(data['is_warning']){
          this.toastr.warning('', data['error_message2'], {
            timeOut: 3000, positionClass: 'toast-top-right', progressBar: true
          });
        }
      } else {
        this.toastr.error('', data['error_message'], {
          timeOut: 4000, positionClass: 'toast-top-right', progressBar: true
        });

        if(data['is_warning']){
          this.toastr.warning('', data['error_message2'], {
            timeOut: 3000, positionClass: 'toast-top-right', progressBar: true
          });
        }
      }
    }).catch(data =>{
      if(data['error_message'] == null){
        this.toastr.error('Please try again', 'There was a problem upon updating your dispatch.', {
          timeOut: 4000, positionClass: 'toast-top-right', progressBar: true
        });
      }else if(data['error_message'] == ' '){
        this.toastr.error('Please try again', 'There was a problem upon updating your dispatch.', {
          timeOut: 4000, positionClass: 'toast-top-right', progressBar: true
        });
      }else{
        this.toastr.error('Please try again', data["error_message"], {
          timeOut: 4000, positionClass: 'toast-top-right', progressBar: true
        });
      }
      this.returnConsignmentIndex = null;
      this.returningConnoteList = [];
    }).finally(async ()=>{
      await this.getPairing();
      await this.getAllRuns();
      await this.getActivities();
      this.returnConsignmentIndex = null;
      this.returningConnoteList = [];
      this.isReturnedConsignment = false;
    });
  }

  getFinalServiceType(equipment){
    let service_type = '';
    if(equipment.length == 1){ //truck 
      if(equipment[0].fleet_type_id == 1){
        if (this.service_types.some(service => service.abbreviation === ServiceTypeAbbreviations.UTE)) {
          service_type = ServiceTypeAbbreviations.UTE;
        } else {
          service_type = ServiceTypeAbbreviations.Rigid;
        }
      } else if(equipment[0].fleet_type_id == 2){
        if(equipment[0].fleet_subtype_id == 6) service_type = ServiceTypeAbbreviations.TwoTonne4P;
        if(equipment[0].fleet_subtype_id == 7) service_type = ServiceTypeAbbreviations.SixTonne8P;
        if(equipment[0].fleet_subtype_id == 8) service_type = ServiceTypeAbbreviations.TwelveTonne14P;
        if(equipment[0].fleet_subtype_id == 10) service_type = ServiceTypeAbbreviations.TenPalletRigid;
        if(equipment[0].fleet_subtype_id == 11) service_type = ServiceTypeAbbreviations.TwoTonne6P;
        if(equipment[0].fleet_subtype_id == 12) service_type = ServiceTypeAbbreviations.SixTonne10P;
        if(equipment[0].fleet_subtype_id == 13) service_type = ServiceTypeAbbreviations.EightTonne12P;
        if(equipment[0].fleet_subtype_id == 14) service_type = ServiceTypeAbbreviations.TwelveTonne12P;
      } else { //to catch other fleet types
        if(equipment[0].fleet_subtype_id == 1) service_type = ServiceTypeAbbreviations.SemiPMOnly;
        if(equipment[0].fleet_subtype_id == 2) service_type = ServiceTypeAbbreviations.BDoublePMOnly;

      }
    } else { // with trailers
      let temp = equipment.find(x=> x.fleet_subtype_id != 4 &&  x.fleet_subtype_id != 5);
      let trls =  equipment.filter(x=> x.fleet_subtype_id == 4 ||  x.fleet_subtype_id == 5);

      if(temp.fleet_subtype_id == 3){
        service_type = ServiceTypeAbbreviations.SemiPMWithTrailers;
      } else if(temp.fleet_subtype_id == 4){
        if(trls.length == 1){
          if(trls[0].fleet_subtype_id == 4) service_type = ServiceTypeAbbreviations.BDoublePMWithATrailer;
          if(trls[0].fleet_subtype_id == 5) service_type = ServiceTypeAbbreviations.SemiPMOnly;
        } else if (trls.length == 2){
          service_type = ServiceTypeAbbreviations.BDoublePMOnly;
        } else if (trls.length > 2){
          service_type = ServiceTypeAbbreviations.RoadTrain;
        }
      }
    }

    // Find the matching service type in the fetched list
    const matchingService = this.service_types.find(
      (service) => service.abbreviation === service_type
    );
    console.log(matchingService,'here2');
    return matchingService?.id;
  }

  async autoSetLocation(sites){
    let acts = sites, start = acts[0], end = acts[acts.length-1], route; 

      if ((start.run_action_id == 1 || start.run_action_id == 4 || start.run_action_id == 5 || start.run_action_id == 10 || start.run_action_id == 14) &&
        (end.run_action_id == 2 || end.run_action_id == 3 || end.run_action_id == 6 || end.run_action_id == 9 || end.run_action_id == 15)) {
          route = this.routes.find(x=>x.start_state_id == start.state_id && x.end_state_id == end.state_id && x.changeover_state_id == null);

        if(route == undefined){//create route
          let temp = {
            'id': '',
            'description': 'Local Dispatch [' + start.state_abbrev+' - '+end.state_abbrev+']',
            'start_state_id': start.state_id,
            'end_state_id': end.state_id,
            'changeover_state_id': null,
            'created_by': this.admin_user
          
          }
          await this.dispatchService.createRoute(temp).toPromise().then(data => {
            if(data['error'] == false){
              this.getData();
              route = data['run_route'];
            }
            console.log(data['message'])
          });

        } else route = route.id
      }
    return route;
  }

  async reloadConsignments(list){
    let old_count = this.connotesListing.length;

    if(list == 'consignment'){
      this.list1Spinner = true;
      await this.getActivities();
      let new_count = this.connotesListing.length;
      setTimeout(() => { this.list1Spinner = false; }, 700);

      let total_count = new_count - old_count;
      if(total_count > 0){
        this.toastr.success('', total_count + ' new bookings', {
          timeOut: 4000, positionClass: 'toast-top-left', progressBar: true
        });
      }
      console.log(total_count, ' new bookings')
    } else if(list == 'manifest'){
      this.list3Spinner = true;
      await this.getAllRuns();
      setTimeout(() => { this.list3Spinner = false; }, 700);
    } else if(list == 'carrier'){
      this.list2Spinner = true;
      await this.getPairing();
      await this.getAllRuns();
      setTimeout(() => { this.list2Spinner = false; }, 700);
    }
  }

  // Consignment, Carrier, and Manifest Open Modal
  public openSearchModal(panel){
    this.panelModal = panel;
    this.modal.open(this.filterModal, { backdrop: 'static', size: 'lg', centered: true });
  }

  // Filters Data
  public get filteredDataManifest(){
    const fForm = this.filterForm.controls
    let filtered = []

    switch(this.panelModal){
      case 'consignment':{     
        filtered = [...this.mainconsignmentsList];

        if(fForm['connote_controlNo'].value !=''){ // connote - control number
          filtered = filtered.filter((data)=>{
            return data.control_no?.toLowerCase().indexOf(fForm['connote_controlNo'].value.toLowerCase()) !== -1 || !fForm['connote_controlNo'].value.toLowerCase();
          });
        }

        if(fForm['connote_customer'].value != ''){
          filtered = filtered.filter((con)=>{ //connote - customer name
            return con.company_name?.toLowerCase().indexOf(fForm['connote_customer'].value.toLowerCase()) !== -1 || !fForm['connote_customer'].value.toLowerCase();
          }); 
        }

        if(fForm['connote_referenceNo'].value != ''){
          filtered = filtered.filter((con)=>{ //connote - ref no
            if(con.customer_reference_no != null){
              return con.customer_reference_no?.toLowerCase().indexOf(fForm['connote_referenceNo'].value.toLowerCase()) !== -1 || !fForm['connote_referenceNo'].value.toLowerCase();
            }
          }); 
        }

        filtered = filtered.filter((data)=>{ // connote - order type
          if(fForm['connote_orderType'].value == 'Purchase Order'){
            return data.wh_order_type == 'purchase_order';
          } else if(fForm['connote_orderType'].value == 'Sales Order'){
            return data.wh_order_type == 'sales_order';
          } else if(fForm['connote_orderType'].value == "All") return data;
        });

        if(fForm['connote_warehouse'].value != '0'){
          let warehouse = this.wh_sites.find(x=>x.id == Number(fForm['connote_warehouse'].value));
          if(warehouse.location_id != null){
            filtered = filtered.filter((data)=>{ //connote - warehouse
              let act = data.connote_sites.filter((val)=>{
                return val.location_id == warehouse.location_id;
              })

              if(act.length != 0) return data;
            })
          }
        }
        break;
      } case 'carrier':{
        filtered = [...this.maincarrierList];
        
        filtered = filtered.filter((data)=>{ //carrier - status
          let st = fForm['carrier_hasJob'].value

          if(st == 'All'){
            return data
          } else if(st == 'WithJobs'){
            return data.currentManifest_id != null
          } else if(st == 'WithoutJobs'){
            return data.currentManifest_id == null
          }
        });

        if(fForm['carrier_name'].value !=''){ // carrier - name
          filtered = filtered.filter((data)=>{
            let fullName = data.first_name + ' ' + data.last_name;
            if(fullName?.toLowerCase().indexOf(fForm['carrier_name'].value.toLowerCase()) !== -1 || !fForm['carrier_name'].value.toLowerCase()){
              return data
            }
          });
        }

        if(fForm['carrier_hasJob'].value == 'WithJobs'){
          filtered = filtered.filter((data)=>{
              let con = data.assignedConnotes;

                if(fForm['carrier_controlNo'].value !=''){ // carrier - control number
                  con = con.filter(cc=>{
                    return cc.control_no?.toLowerCase().indexOf(fForm['carrier_controlNo'].value.toLowerCase()) !== -1 || !fForm['carrier_controlNo'].value.toLowerCase();
                  });
                }
                if(fForm['carrier_orderType'].value != ''){ // carrier - order type
                  con = con.filter((con)=>{
                    if(fForm['carrier_orderType'].value == 'Purchase Order'){
                      return con.wh_order_type == 'purchase_order';
                    } else if(fForm['carrier_orderType'].value == 'Sales Order'){
                      return con.wh_order_type == 'sales_order';
                    } else if(fForm['carrier_orderType'].value == "All") return con;
                  });
                }
    
                if(con.length != 0) return data
                
          });
        }

          if(fForm['carrier_warehouse'].value != '0'){
            let warehouse = this.wh_sites.find(x=>x.id == Number(fForm['carrier_warehouse'].value));
            if(warehouse.location_id != null){
              filtered = filtered.filter((data)=>{ //carrier - warehouse
                let act = data.assignedSite.filter((val)=>{
                  return val.location_id == warehouse.location_id;
                })
  
                if(act.length != 0) return data;
              })
            }
          }
          if(fForm['carrier_DrvStandard'].value != '0'){
            let standard = this.driverStandards.find(x=>x.id == Number(fForm['carrier_DrvStandard'].value));
              filtered = filtered.filter((data)=>{ //carrier - driver standard
                return data.driver_standard_id == standard.id
              })
          }

        break;
      } case 'manifest':{
        filtered = [...this.mainManifestList];

        if(fForm['manifest_controlNo'].value !=''){ // manifest - control number
          filtered = filtered.filter((data)=>{
            return data.control_no?.toLowerCase().indexOf(fForm['manifest_controlNo'].value.toLowerCase()) !== -1 || !fForm['manifest_controlNo'].value.toLowerCase();
          });
        }

        filtered = filtered.filter((data)=>{ // manifest - order type
          let connotes = data.connotes
          if(fForm['manifest_orderType'].value != ''){
            connotes = connotes.filter((con)=>{
              if(fForm['manifest_orderType'].value == 'Purchase Order'){
                return con.wh_order_type == 'purchase_order';
              } else if(fForm['manifest_orderType'].value == 'Sales Order'){
                return con.wh_order_type == 'sales_order';
              } else if(fForm['manifest_orderType'].value == "All") return con;
            });
          }
          
          if(fForm['manifest_customer'].value != ''){
            connotes = connotes.filter((con)=>{ //manifest - customer name
              return con.customer?.toLowerCase().indexOf(fForm['manifest_customer'].value.toLowerCase()) !== -1 || !fForm['manifest_customer'].value.toLowerCase();
              }); 
          }

          if(connotes.length != 0) return data; 
        });
        if(fForm['manifest_status'].value){
          filtered = filtered.filter((data)=>{ //manifest - status
            let st = this.subStatuses[fForm['manifest_status'].value-1].name;
            if(Number(fForm['manifest_status'].value) == 1){
              return data
            } else {
              return data.sub_status?.toLowerCase().indexOf(st.toLowerCase()) !== -1 || !st.toLowerCase();
            }
          });
        }

        if(fForm['manifest_warehouse'].value != '0'){
          let warehouse = this.wh_sites.find(x=>x.id == Number(fForm['manifest_warehouse'].value));
          if(warehouse.location_id != null){
            filtered = filtered.filter((data)=>{ //manifest - warehouse
              let act = data.activities.filter((val)=>{
                return val.location_id == warehouse.location_id;
              })

              if(act.length != 0) return data;
            })
          }
        }


        break;
      } default: break;
    }
    // console.log('Filter Results for ', this.panelModal, ': ', filtered);
    return filtered;
  }

  async searchFilters(filterValues){
    if(this.panelModal == 'manifest'){
      this.manifestList = this.filteredDataManifest
    } else if(this.panelModal == 'consignment'){
      this.connotesListing = this.filteredDataManifest
    }else if(this.panelModal == 'carrier'){
      if(filterValues['carrier_hasJob'] == 'All' || filterValues['carrier_hasJob'] == 'WithoutJobs'){
        this.filterForm.patchValue({carrier_warehouse: '0', carrier_orderType: 'All'})
      }
      this.carrierList = this.filteredDataManifest
    }
    this.modal.dismissAll();
  }

  setCarrierStatus(type:string){
    const ctrl = this.filterForm.controls['carrier_hasJob']
      ctrl.patchValue(type);
  }

  getCarrierStatus(){
    const selectedStatus = this.filterForm.controls['carrier_hasJob'].value
    return selectedStatus;
  }

  setOrderType(type:string){
    if(this.panelModal == 'manifest'){
      const ctrl = this.filterForm.controls['manifest_orderType']
      ctrl.patchValue(type);
    } else if(this.panelModal == 'consignment'){
      const ctrl = this.filterForm.controls['connote_orderType']
      ctrl.patchValue(type);
    } else if(this.panelModal == 'carrier'){
      const ctrl = this.filterForm.controls['carrier_orderType']
      ctrl.patchValue(type);
    } 
  }
  
  getOrderType() { 
    let selectedOrderType: any;

    if(this.panelModal == 'consignment'){
      selectedOrderType = this.filterForm.controls['connote_orderType'].value
    } else if(this.panelModal == 'carrier'){
      selectedOrderType = this.filterForm.controls['carrier_orderType'].value
    } if(this.panelModal == 'manifest'){
      selectedOrderType = this.filterForm.controls['manifest_orderType'].value
    }
    return selectedOrderType; 
  }

  resetFilters(panel){
    if(panel == 'manifest'){
      this.filterForm.patchValue({
        manifest_controlNo:'',
        manifest_customer: '',
        manifest_orderType: 'All',
        manifest_warehouse: '0',
        manifest_status: '1',
      });

      this.manifestList = this.filteredDataManifest
    } else if(panel == 'consignment'){
      this.filterForm.patchValue({
        connote_controlNo : '',
        connote_customer : '',
        connote_referenceNo : '',
        connote_orderType : 'All',
        connote_warehouse: '0',
        connote_serviceType: ''
      });

      this.connotesListing = this.filteredDataManifest
    } else if(panel == 'carrier'){
      this.filterForm.patchValue({
        carrier_name           : '',
        carrier_controlNo      : '',
        carrier_equipment      : '',
        carrier_hasJob         : 'All',
        carrier_orderType      : 'All',
        carrier_warehouse      : '0',
        carrier_DrvStandard    : '0',
      })
      this.carrierList = this.filteredDataManifest

    }
  }
  // Multiple selection

  // Select all items in the list
  checkAllConsignment(ev) {
    this.connotesListing.forEach((x, i) => {
      x.is_checked = ev.target.checked;
    });

    let data = document.getElementsByClassName('target-consignment');
    for (let i = 0; i < data.length; i++) {
      if (data[i].className.includes('ex-over') && this.connotesListing[i].is_checked === true) {
      } else {
        this.addClass(data[i], 'ex-over');
      }
    }
  }

  // Select certain items in the list
  clickConsignmentItem(i) {
    let selected= 'selectedConsignment' + i;
    let val = document.getElementById(selected);
    this.addClass(val, 'ex-over');
    this.connotesListing[i].is_checked = !this.connotesListing[i].is_checked;
  }

  // Move selected consignment to carrier panel
  moveto() {
    let target = document.getElementsByClassName('target-consignment');
    for (let i = target.length - 1; i >= 0; i--) {
      if (target[i].className.includes('ex-over') && i >= 0 && this.connotesListing[i] != undefined) {
        this.removeClass(target[i], 'ex-over');
        this.movedItems.push(this.connotesListing[i]);
        this.connotesListing.splice(i, 1);
      }
    }
    this.selectedConnote = this.movedItems;
  }

  // Move selected carrier's consignment to consignment panel
  moveback(item, run_id){
    this.removeConnote(item, run_id)
  }

  private addClass(el: any, name: string): void {
    if (!this.hasClass(el, name) && !el.is_checked === true) {
      el.className = (el.className) ? [el.className, name].join(' ') : name;
    } else {
      this.removeClass(el, name);
    }
  }

  private removeClass(el: any, name: string): void {
    if (this.hasClass(el, name)) {
      el.className = el.className.replace(new RegExp('(?:^|\\s+)' + name + '(?:\\s+|$)', 'g'), ' ');
    }
  }

  private hasClass(el: any, name: string): any {
    return new RegExp('(?:^|\\s+)' + name + '(?:\\s+|$)').test(el.className);
  }

  async processDateRange() {
		this.dateRangeStart = moment(this.jobDateRange.start?._d).format('YYYY-MM-DD');
		this.dateRangeEnd = moment(this.jobDateRange.end?._d).format('YYYY-MM-DD');

    if(this.singleDate) this.dateFilter='range';

    if(document.querySelector('div.ltr').classList.contains('shown')){
      document.querySelector('div.ltr').classList.remove('shown');
      document.querySelector('div.ltr').classList.add('hidden');
    }

    if(this.dateFilter != ''){
      this.loadManifestSpinner = true;
      await this.getAllRuns(this.dateStatusFilter, this.dateFilter, this.dateRangeStart, this.dateRangeEnd);
    }
	}

  async onChangeDateDropdown(selected) {
		if (selected != 'range') {
      if(this.dateFilter!=''){
        this.loadManifestSpinner = true;

        this.toggleCalendar();
        
        let dateRangeLabel = document.querySelector('option#date_range_label');

        if(this.singleDate==true){
          this.singleDate=false;
          dateRangeLabel.innerHTML = 'Custom date range';
        }

        await this.getAllRuns(this.dateStatusFilter, this.dateFilter, this.dateRangeStart, this.dateRangeEnd);
      }
		}
  }

  checkActivities(tasks){
    const doneActivities = tasks.filter(x=>{return x.run_event_id != null});
    if(doneActivities.length != 0){ return true;} return false;
  }

  isEnabled(name){
		let is_enabled = false;
		is_enabled = this.svc_components.isComponentEnabled(name);
		return is_enabled
	}
}